
@if (getPermission('Service_Section')?.visible) {
<div class="card p-2">
  <div class="card-header d-flex ps-0" data-bs-toggle="collapse" href="#collapseServiceSection">
    <a class="card-link flex-fill">RIMS - Service</a> {{isFormPresent('service') ? '' : '`'}}
    <i class="fas fa-chevron-up"></i>
  </div>
  <div id="collapseServiceSection" class="collapse show">
    <div class="card-body-section p-4">
@if(!reloadSection) {

      <div class="row" [formGroup]="serviceForm">
            <!-- ===============================================COLUMN 1 Begins============================================= -->
            <div class="col-3" style="margin-right: 20px;">
              <!-- column 1 -->
              <div class="row">
                @if (getPermission('Service_enable')?.visible) {
                  <div class="col-6">
                    <!-- Row 1 Column 1 -->
                    <div class="row mb-4">
                      <div class="col-12 customLabel">
                        <ejs-checkbox #serviceEnableCb
                        [label]="UPServiceFields.enableDesc" [formControlName]="UPServiceFields.isEnabled"
                        [disabled]="!getPermission('Service_enable')?.enable"
                        (change)="onEnableSectionCheckboxChange($event)"></ejs-checkbox>
                      </div>
                    </div>
                  </div>
                }
                @if (getPermission('Service_resetPreferencesButton')?.visible) {
                  <div class="col-5" style="padding: 0px; font-size: 0.7rem;">
                    <a href="javascript:" style="text-decoration: none; font-size: 0.7rem;"
                    [ngClass]="{'disabledHyperlink': !getPermission('Service_resetPreferencesButton')?.enable  || !isSectionEnabled}"
                      (click)="clearPersistence()" title="Reset Persistence"><i class="fas fa-sync pb-2"></i>&nbsp;Reset
                      Persistence</a>
                  </div>
                  }

                @if (getPermission('Service_rolesDropdown')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 4 -->
                  <div class="row">
                    <div class="col-3 customLabel">{{UPServiceFields.roleDesc}}:
                    </div>
                    <div class="col-9">
                      <ejs-dropdownlist #rolesDDL [dataSource]="rolesData"
                        [formControlName]="UPServiceFields.role"
                        [fields]="{ text: 'displayName', value: 'role' }"
                        [readonly]="getPermission('Service_rolesDropdown')?.readOnly || !isSectionEnabled"
                        [enabled]="getPermission('Service_rolesDropdown')?.enable && isSectionEnabled"
                        (change)="onRolesChange($event);" [placeholder]='UPServiceFields.roleDesc'>
                      </ejs-dropdownlist>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_rolesDropdown')?.required && serviceForm.controls[UPServiceFields.role].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_startDate')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 4 -->
                  <div class="row">
                    <div class="col-3 customLabel">{{UPServiceFields.startDateDesc}}:
                      @if (getPermission('Service_startDate')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-9">
                      <ejs-datepicker [min]="usersService.getMinStartDate()" [value]="todayDate"
                        [enabled]="getPermission('Service_startDate')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Service_startDate')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPServiceFields.startDate" (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-startDate change');setDateToZeroZero($event, UPServiceFields.startDate);"
                        [placeholder]="UPServiceFields.startDateDesc"></ejs-datepicker>
                        <div class="field-error" [ngStyle]="{visibility: checkDatesFor('SD').isInvalid ? 'visible' : 'hidden'}">{{checkDatesFor('SD')?.message}}</div>

                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_endDate')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 4 -->
                  <div class="row">
                    <div class="col-3 customLabel">{{UPServiceFields.endDateDesc}}:
                      @if (getPermission('Service_endDate')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-9">
                      <ejs-datepicker [min]="getMaxED()" [value]="todayDate"
                        [enabled]="getPermission('Service_endDate')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Service_endDate')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPServiceFields.endDate" (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-endDate change');setDateToZeroZero($event, UPServiceFields.endDate);"
                        [placeholder]="UPServiceFields.endDateDesc"></ejs-datepicker>
                        <div class="field-error" [ngStyle]="{visibility: checkDatesFor('ED')?.isInvalid ? 'visible' : 'hidden'}">{{checkDatesFor('ED')?.message}}</div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>

            <!-- ===============================================COLUMN 2 Begins============================================= -->
            <div class="col-3" style="margin-right: 20px;">
              <!-- column 2 -->
              <div class="row">
                @if (getPermission('Service_employeeId')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.employeeIdDesc}}:
                      @if (getPermission('Service_employeeId')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">
                      <ejs-combobox
                      #employeeIdCombo
                      [sortOrder]="'Ascending'"
                      [allowFiltering]="true"
                      [allowCustom]="false"
                      [filterType]="'contains'"
                      [formControlName]="UPServiceFields.employeeId"
                      [dataSource]="employeeIdsDataSource"
                      [fields]="{ value: 'employeeId', text: 'employeeIdDesc' }"
                      (filtering)="onFilteringEmployeeId($event)"
                      (change)="onEmployeeIdChange($event, $safeNavigationMigration($event?.itemData))"
                      [placeholder]='UPServiceFields.employeeIdDesc'>
                        <!-- Dropdown item template -->
                        <!-- <ng-template #itemTemplate let-data>
                          {{ data.employeeId }} - {{ data.employeeName }}
                        </ng-template> -->

                        <!-- Selected value template (what shows after selection) -->
                        <!-- <ng-template #valueTemplate let-data>
                          {{ data.employeeId }} - {{ data.employeeName }}
                        </ng-template> -->
                    </ejs-combobox>
                    <a class="advanced-search-button" style="font-size: 0.7rem; float: right;"
                    [ngClass]="{'disabledHyperlink': !isSectionEnabled || getPermission('Service_employeeId')?.enable === false || getPermission('Service_employeeId')?.readOnly === true}"
                    (click)="!(!isSectionEnabled || getPermission('Service_employeeId')?.enable === false || getPermission('Service_employeeId')?.readOnly === true) && viewEmployees()" href="javascript:" >Advanced Search</a>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && (getPermission('Service_employeeId')?.enable === true || getPermission('Service_employeeId')?.readOnly === false) && serviceForm.controls[UPServiceFields.employeeId].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }


                @if (getPermission('Service_viewAddress')?.visible) {
                  <div class="col-12 mb-2" style="height: 130px;">
                    <div class="customer-address disabled-field p-2 border">
                      <ng-container *ngIf="hasAddress; else noAddress">
                        <div>{{ getFieldValue(UPServiceFields.name) }}</div>
                        <div>{{ getFieldValue(UPServiceFields.address) }}</div>
                        <div>{{ getAddressOfUser() }}</div>
                        <div>{{ getFieldValue(UPServiceFields.country) }}</div>
                      </ng-container>
                      <ng-template #noAddress>
                        <p class="mt-4 pb-1 fw-normal fst-italic text-center">
                          This user doesn't have any address.
                        </p>
                      </ng-template>
                    </div>
                  </div>
                }

                @if (getPermission('Service_iscCode')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.iscCodeDesc}}:
                      @if (getPermission('Service_iscCode')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">
                       <ejs-textbox trimOnBlur (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-iscCode change')"
                        [enabled]="getPermission('Service_iscCode')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Service_iscCode')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPServiceFields.iscCode"
                        [placeholder]="UPServiceFields.iscCodeDesc"></ejs-textbox>
                    @if(getPermission('Service_advancedSearchIscCode')?.visible) {
                      <a class="advanced-search-button" style="font-size: 0.7rem; float: right;" href="javascript:"
                      [ngClass]="{'disabledHyperlink': !getPermission('Service_advancedSearchIscCode')?.enable  || !isSectionEnabled}"
                      (click)="getPermission('Service_advancedSearchIscCode')?.enable && isSectionEnabled ? showAdvancedISCCodePopup = true: false;">Advanced Search</a>
                    }
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_iscCode')?.required && serviceForm.controls[UPServiceFields.iscCode].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_iscSuplierCode')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.iscSupplierCodeDesc}}:
                      @if (getPermission('Service_iscSuplierCode')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">
                       <ejs-textbox trimOnBlur (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-iscSupplierCode change')"
                        [enabled]="getPermission('Service_iscSuplierCode')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Service_iscSuplierCode')?.readOnly || !isSectionEnabled" [htmlAttributes]="{maxLength: 9}"
                        [formControlName]="UPServiceFields.iscSupplierCode"
                        [placeholder]="UPServiceFields.iscSupplierCodeDesc"></ejs-textbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_iscSuplierCode')?.required && serviceForm.controls[UPServiceFields.iscSupplierCode].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                <!-- getPermission('Service_viewISCEmployeesLink')?.visible -->
                <!-- getPermission('Service_viewISCEmployeesLink')?.enable -->
                 <!-- roleId = 8 means ISC Manager -->
                @if (getFieldValue(UPServiceFields.roleId) == 8 ) {
                <div class="col-11 mb-4">
                  <div class="row">
                    <div class="col-4 customLabel">ISC Employees:</div>
                    <div class="col-8 pt-1 d-flex justify-content-end ">
                      <a href="javascript:" style="text-decoration: none; font-size: 0.7rem;"
                      [ngClass]="{'disabledHyperlink': !isSectionEnabled }"
                        (click)="viewEmployees('ISC')">View ISC Employees</a>
                    </div>
                  </div>
                </div>
                }

                <!-- getPermission('Service_viewISCEmployeesLink')?.visible -->
                <!-- getPermission('Service_viewISCEmployeesLink')?.enable -->
                 <!-- roleId = 6 means ISC -->

                @if (getFieldValue(UPServiceFields.roleId) == 6 || getFieldValue(UPServiceFields.roleId) == 23) {
                <div class="col-11 mb-2">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">ISC Manager:
                      @if (isISCManagerRequired && !serviceForm.controls[UPServiceFields.iscManager]?.value) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">
                       <ejs-textbox trimOnBlur (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-iscManager change')" 
                        [formControlName]="UPServiceFields.iscManager" [enabled]="getPermission('Service_mobile')?.enable && isSectionEnabled"
                        [readonly]="true"
                        [placeholder]="UPServiceFields.iscManagerDesc"></ejs-textbox>
                         @if(getPermission('Service_employeeId')?.visible && !isISCManagerLoggedIn && (getFieldValue(UPServiceFields.roleId) == 6 || getFieldValue(UPServiceFields.roleId) == 23) && (showISCManagerHyperlink || isAdminLoggedIn)) {
                      <a class="advanced-search-button" style="font-size: 0.7rem; float: right;"
                      [ngClass]="{'disabledHyperlink': !isSectionEnabled}"
                      (click)="viewEmployees('ISCManager')" href="javascript:" >Select ISC Manager</a>
                      }
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && isISCManagerRequired && !serviceForm.controls[UPServiceFields.iscManager]?.value) ? 'visible' : 'hidden'}">
                        Field is required</div>
                       
                    </div>
                    
                  </div>
                </div>
                }
                <!-- @if (getFieldValue(UPServiceFields.roleId) == 6 ) {
                <div class="col-12 mb-4">
                  <div class="row">
                    <div class="col-3 customLabel">ISC Manager:</div>
                    <div class="col-6 pt-1">
                      <a href="javascript:" style="text-decoration: none; font-size: 0.7rem;"
                      [ngClass]="{'disabledHyperlink': !(getFieldValue(UPServiceFields.employeeId)  && isSectionEnabled) }"
                        (click)="getFieldValue(UPServiceFields.employeeId) && isSectionEnabled ? showAdvancedISCEmployeesPopup = true: false;">Select ISC Manager</a>
                    </div>
                  </div>
                </div>
                } -->

                @if (getPermission('Service_payViaDropwon')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.payViaDesc}}:
                      @if (getPermission('Service_payViaDropwon')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">

                      <ejs-dropdownlist #payViaDDL [dataSource]="payViaData"
                        [fields]="{ text: 'text', value: 'displayOrder' }"
                        [readonly]="getPermission('Service_payViaDropwon')?.readOnly || !isSectionEnabled"
                        [enabled]="getPermission('Service_payViaDropwon')?.enable && isSectionEnabled" [formControlName]="UPServiceFields.payViaInt"
                        [placeholder]="'Select ' + UPServiceFields.payViaDesc"
                        (change)="$event?.isInteracted && sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-payVia change')"
                        >
                      </ejs-dropdownlist>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_payViaDropwon')?.required && serviceForm.controls[UPServiceFields.payViaInt].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_partsSalesOfficesDropdown')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.partsSalesOfficeDesc}}:
                      @if (getPermission('Service_partsSalesOfficesDropdown')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">

                      <ejs-dropdownlist #partsOfficeDDL [dataSource]="partsOfficeData"
                        [fields]="{value : 'displayOrder', text: 'text' }"
                        [formControlName]="UPServiceFields.partsSalesOfficeInt"
                        [readonly]="getPermission('Service_partsSalesOfficesDropdown')?.readOnly || !isSectionEnabled"
                        [enabled]="getPermission('Service_partsSalesOfficesDropdown')?.enable && isSectionEnabled" (change)="$event?.isInteracted && sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-partsSalesOffice change')"
                        [placeholder]="'Select ' + UPServiceFields.partsSalesOfficeDesc">
                      </ejs-dropdownlist>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_partsSalesOfficesDropdown')?.required && serviceForm.controls[UPServiceFields.partsSalesOfficeInt].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }


                @if (getPermission('Service_mobile')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 2 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.mobileDesc}}:
                      @if (getPermission('Service_mobile')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">
                       <ejs-textbox trimOnBlur (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-mobile change')" style="padding-left: 0px; margin-left: 0px;"
                        [formControlName]="UPServiceFields.mobile" [enabled]="getPermission('Service_mobile')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Service_mobile')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPServiceFields.mobile"
                        [placeholder]="UPServiceFields.mobileDesc"></ejs-textbox>
                      @if(isFormSubmitted && getPermission('Service_mobile')?.required &&
                      serviceForm.controls[UPServiceFields.mobile].invalid) {
                        <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_mobile')?.required && serviceForm.controls[UPServiceFields.mobile].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                      } @else {
                        <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && (serviceForm.controls[UPServiceFields.mobile].invalid || !isMobileNumberValid)) ? 'visible' : 'hidden'}">
                        Field is Invalid</div>
                      }
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_email')?.visible) {
                <div class="col-11">
                  <!-- Row 2 Column 2 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.emailDesc}}:
                      @if (getPermission('Service_email')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">
                       <ejs-textbox trimOnBlur="email"
                        [enabled]="getPermission('Service_email')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Service_email')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPServiceFields.email" (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-email change')"
                        [placeholder]="UPServiceFields.emailDesc"></ejs-textbox>
                      @if(isFormSubmitted && getPermission('Service_email')?.required &&
                      serviceForm.controls[UPServiceFields.email].invalid) {
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_email')?.required && serviceForm.controls[UPServiceFields.email].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                      } @else {
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && (serviceForm.controls[UPServiceFields.email].invalid || !isEmailAddressValid)) ? 'visible' : 'hidden'}">
                        Field is Invalid</div>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>

            <!-- ===============================================COLUMN 3 Begins============================================= -->
            <div class="col-3" style="margin-right: 20px;">
              <!-- column 3 -->
              <div class="row">
                @if (getPermission('Service_serviceDepartment')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-5 customLabel">{{UPServiceFields.serviceDeptDesc}}:
                      @if (getPermission('Service_serviceDepartment')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-7">
                        
                      <ejs-dropdownlist #sdDDL [dataSource]="serviceDeptsDataDDL" [title]="serviceDeptTitle()"
                        [formControlName]="UPServiceFields.serviceDept"
                        [fields]="{ text: 'description', value: 'serviceDepartment' }" (change)="$event?.isInteracted && sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-serviceDept change')" [placeholder]='UPServiceFields.serviceDeptDesc'>
                      </ejs-dropdownlist>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_serviceDepartment')?.required && serviceForm.controls[UPServiceFields.serviceDept].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                    
                    @if (serviceForm.get(UPServiceFields.role)?.value === UserRoles.rimsCsa) {
                    <div class="col-12 can-complete-claims">
                      <ejs-checkbox [label]="UPServiceFields.canCompleteClaimsDesc" [formControlName]="UPServiceFields.canCompleteClaims"
                        [disabled]="!canEditCanCompleteClaims"
                        (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-canCompleteClaims change')"></ejs-checkbox>
                      <div class="can-complete-claims-hint">
                        <i class="fas fa-info-circle"></i>
                        <span>{{UPServiceFields.canCompleteClaimsHint}}</span>
                      </div>
                    </div>
                    }

                    @if (droSetup) {
                    <div class="col-12 can-complete-claims can-setup-dro">
                      <label class="can-setup-dro-label" [class.disabled]="!droSetup.editable"
                        [title]="droSetup.editable ? '' : 'You cannot change this permission for this user.'">
                        <input type="checkbox" [checked]="droSetupValue" [disabled]="!droSetup.editable"
                          (change)="onDroSetupChange($any($event.target).checked)" />
                        Can Setup DRO Forms
                      </label>
                      <div class="can-complete-claims-hint">
                        <i class="fas fa-info-circle"></i>
                        <span>This user can create, edit, activate and deactivate reading forms such as DRO Readings.</span>
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
                @if (getPermission('Service_warehouse')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-5 customLabel">{{UPServiceFields.warehouseDesc}}:
                      @if (getPermission('Service_warehouse')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-7">
                       <ejs-textbox trimOnBlur (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-warehouse change')"
                        [enabled]="getPermission('Service_warehouse')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Service_warehouse')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPServiceFields.warehouse"
                        [placeholder]="UPServiceFields.warehouseDesc"></ejs-textbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_warehouse')?.required && serviceForm.controls[UPServiceFields.warehouse].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                <!-- @if (getPermission('Service_serviceCar')?.visible) {
                <div class="col-11">
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.serviceCarDesc}}:
                      @if (getPermission('Service_serviceCar')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-8">
                       <ejs-textbox trimOnBlur (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData})"
                        [enabled]="getPermission('Service_serviceCar')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Service_serviceCar')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPServiceFields.serviceCar"
                        [placeholder]="UPServiceFields.serviceCarDesc"></ejs-textbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_serviceCar')?.required && serviceForm.controls[UPServiceFields.serviceCar].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                } -->
                @if (getPermission('Service_serviceManager')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-5 customLabel">{{UPServiceFields.serviceManagerDesc}}:
                      @if (getPermission('Service_serviceManager')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-7">
                       <ejs-textbox trimOnBlur (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-serviceManager change')"
                        [enabled]="getPermission('Service_serviceManager')?.enable && isSectionEnabled"
                        [readonly]="getPermission('Service_serviceManager')?.readOnly || !isSectionEnabled"
                        [formControlName]="UPServiceFields.serviceManager"
                        [placeholder]="UPServiceFields.serviceManagerDesc"></ejs-textbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_serviceManager')?.required && serviceForm.controls[UPServiceFields.serviceManager].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
               
                @if (getPermission('Service_T1LaborRate')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-5 customLabel">{{UPServiceFields.t1LaborRateDesc}}:
                      @if (getPermission('Service_T1LaborRate')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-7">
                      <ejs-numerictextbox
                      [placeholder]="UPServiceFields.t1LaborRateDesc" [formControlName]="UPServiceFields.t1LaborRate"
                      [enabled]="getPermission('Service_T1LaborRate')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_T1LaborRate')?.readOnly || !isSectionEnabled"
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [validateDecimalOnType]="true"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-t1LaborRate change')">
                      </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_T1LaborRate')?.required && serviceForm.controls[UPServiceFields.t1LaborRate].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_T2LaborRate')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-5 customLabel">{{UPServiceFields.t2LaborRateDesc}}:
                      @if (getPermission('Service_T2LaborRate')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-7">
                      <ejs-numerictextbox
                      [placeholder]="UPServiceFields.t2LaborRateDesc" [formControlName]="UPServiceFields.t2LaborRate"
                      [enabled]="getPermission('Service_T2LaborRate')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_T2LaborRate')?.readOnly || !isSectionEnabled"
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [validateDecimalOnType]="true"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-t2LaborRate change')">
                      </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_T2LaborRate')?.required && serviceForm.controls[UPServiceFields.t2LaborRate].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_T1CalloutRate')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-5 customLabel">{{UPServiceFields.t1CalloutRateDesc}}:
                      @if (getPermission('Service_T1CalloutRate')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-7">
                      <ejs-numerictextbox
                      [placeholder]="UPServiceFields.t1CalloutRateDesc" [formControlName]="UPServiceFields.t1CalloutRate"
                      [enabled]="getPermission('Service_T1CalloutRate')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_T1CalloutRate')?.readOnly || !isSectionEnabled"
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [validateDecimalOnType]="true"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-t1CalloutRate change')">
                      </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_T1CalloutRate')?.required && serviceForm.controls[UPServiceFields.t1CalloutRate].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_T2CalloutRate')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-5 customLabel">{{UPServiceFields.t2CalloutRateDesc}}:
                      @if (getPermission('Service_T2CalloutRate')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-7">
                      <ejs-numerictextbox
                      [placeholder]="UPServiceFields.t2CalloutRateDesc" [formControlName]="UPServiceFields.t2CalloutRate"
                      [enabled]="getPermission('Service_T2CalloutRate')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_T2CalloutRate')?.readOnly || !isSectionEnabled"
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [validateDecimalOnType]="true"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-t2CalloutRate change')">
                      </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_T2CalloutRate')?.required && serviceForm.controls[UPServiceFields.t2CalloutRate].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_mileageThreshold')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-5 customLabel">{{UPServiceFields.mileageThresholdDesc}}:
                      @if (getPermission('Service_mileageThreshold')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-7">
                      <ejs-numerictextbox
                      [placeholder]="UPServiceFields.mileageThresholdDesc" [formControlName]="UPServiceFields.mileageThreshold"
                      [enabled]="getPermission('Service_mileageThreshold')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_mileageThreshold')?.readOnly || !isSectionEnabled"
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [validateDecimalOnType]="true"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-mileageThreshold change')">
                      </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_mileageThreshold')?.required && serviceForm.controls[UPServiceFields.mileageThreshold].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_mileageRate')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-5 customLabel">{{UPServiceFields.mileageRateDesc}}:
                      @if (getPermission('Service_mileageRate')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-7">
                      <ejs-numerictextbox
                      [placeholder]="UPServiceFields.mileageRateDesc" [formControlName]="UPServiceFields.mileageRate"
                      [enabled]="getPermission('Service_mileageRate')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_mileageRate')?.readOnly || !isSectionEnabled"
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [validateDecimalOnType]="true"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-mileageRate change')">
                      </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_mileageRate')?.required && serviceForm.controls[UPServiceFields.mileageRate].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                } 
                @if (getPermission('Service_additionalServiceDeptsList')?.visible) {
                <div class="col-11">
                  <!-- Column 3 Row 5 -->
                  <div class="row">
                    <div class="col-12">{{UPServiceFields.additionalServiceDepartmentsDesc}}:
                      @if (getPermission('Service_additionalServiceDeptsList')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-12">
                      <div class="service-depts-grid">
                        <inavista-grid #deptsGrid [config]="deptsGridConfig" (rowsSelected)="onDeptsSelected($event)" />
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
            <!-- <div class="col-1"></div> -->
            <!-- ===============================================COLUMN 4 Begins============================================= -->
            <div class="col-2">
              <!-- column 4 -->
              <div class="row">


              @if (getPermission('Service_T1LaborRate')?.visible) {
              <div class="col-11 mb-5">
                <!-- BUSINESS LOGO HERE -->


             <div class="d-flex justify-content-around align-items-end">
                <div class="image-section" #dropElement>
                  <div class="captions">Business Logo</div>
                
                   @if (!pictureURL) {
                    <ng-container>
                      <div class="initials" style="font-size: 42px !important;">logo</div>
                    </ng-container>
                  } @else {
                    <ng-container>
                      <div>
                        <img id="profilePicturePlaceholder" class="rounded"
                          [src]="pictureURL"
                          alt="unsupported image" />
                      </div>
                    </ng-container>
                  }



                  <div class="captions">Drop image (PNG, JPG) files here</div>
                  <input #logoChooser type='file' style="visibility: hidden; position: absolute;" class="image-input"
                    accept=".png,.jpg" (click)="clickAttachmentUpload($event)" />
                  <div class="image-buttons">
                    <button class="border border-secondary btn btn-sm mt-1 px-3 ms-4 me-1"
                    [disabled]="!isSectionEnabled || ((getFieldValue(UPServiceFields.roleId) == 6 || getFieldValue(UPServiceFields.roleId) == 23) && source == 'USER')" (click)="logoChooser?.click()">BROWSE...</button>
                    <i class="fas fa-trash del-icon px-2" (click)="deleteUI('Business Logo')"
                      [ngClass]="{'enabled-icon': isProfilePictureDeletable, 'disabled-icon': (!pictureURL  || !isSectionEnabled || ((getFieldValue(UPServiceFields.roleId) == 6 || getFieldValue(UPServiceFields.roleId) == 23) && source == 'USER')) }"></i>
                  </div>



                </div>
              </div>
              
              
              
              <!-- BUSINESS LOGO HERE -->
            </div>
          }
          <ejs-uploader #logoUpload
        style="visibility: hidden; position: absolute;"
            id='logoUpload'
            [asyncSettings]='path'
            [dropArea]='dropElement'
            [maxFileSize]="3.2e+7"
            (uploading)="beforeFileUpload($event)"
            (created)="onUploaderCreated(logoUpload)"
            (success)="onUploadSuccess($event)"
            (clearing)="onFileClear($event)"
            (actionComplete)="onActionComplete($event)"
            ></ejs-uploader>


                @if (getPermission('Service_laborType')?.visible) {
                <div class="col-12">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.laborTypeDesc}}:
                      @if (getPermission('Service_laborType')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-6">
                       <ejs-textbox trimOnBlur
                      [maxlength]="'15'"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-laborType change')"
                      [enabled]="getPermission('Service_laborType')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_laborType')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPServiceFields.laborType"
                      [placeholder]="UPServiceFields.laborTypeDesc"
                      >
                    </ejs-textbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_laborType')?.required && serviceForm.controls[UPServiceFields.laborType].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_laborTask')?.visible) {
                <div class="col-12">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.laborTaskDesc}}:
                      @if (getPermission('Service_laborTask')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-6">
                       <ejs-textbox trimOnBlur
                      [maxlength]="'15'"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-laborTask change')"
                      [enabled]="getPermission('Service_laborTask')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_laborTask')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPServiceFields.laborTask"
                      [placeholder]="UPServiceFields.laborTaskDesc"
                      >
                    </ejs-textbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_laborTask')?.required && serviceForm.controls[UPServiceFields.laborTask].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_laborCCMP')?.visible) {
                <div class="col-12">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.laborCCMPDesc}}:
                      @if (getPermission('Service_laborCCMP')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-6">
                      <ejs-numerictextbox
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [showSpinButton]="false"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-laborCCMP change')"
                      [enabled]="getPermission('Service_laborCCMP')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_laborCCMP')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPServiceFields.laborCCMP"
                      [placeholder]="UPServiceFields.laborCCMPDesc">
                    </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_laborCCMP')?.required && serviceForm.controls[UPServiceFields.laborCCMP].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_materialCCMP')?.visible) {
                <div class="col-12">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.materialCCMPDesc}}:
                      @if (getPermission('Service_materialCCMP')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-6">
                      <ejs-numerictextbox
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [showSpinButton]="false"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-materialCCMP change')"
                      [enabled]="getPermission('Service_materialCCMP')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_materialCCMP')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPServiceFields.materialCCMP"
                      [placeholder]="UPServiceFields.materialCCMPDesc"
                      >
                    </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_materialCCMP')?.required && serviceForm.controls[UPServiceFields.materialCCMP].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_otherCCMP')?.visible) {
                <div class="col-12">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">{{UPServiceFields.otherCCMPDesc}}:
                      @if (getPermission('Service_otherCCMP')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-6">
                      <ejs-numerictextbox
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [showSpinButton]="false"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-otherCCMP change')"
                      [enabled]="getPermission('Service_otherCCMP')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_otherCCMP')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPServiceFields.otherCCMP"
                      [placeholder]="UPServiceFields.otherCCMPDesc"
                      >
                    </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_otherCCMP')?.required && serviceForm.controls[UPServiceFields.otherCCMP].invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
                @if (getPermission('Service_otherCCMP')?.visible) {
                <div class="col-12">
                  <!-- Row 1 Column 1 -->
                  <div class="row">
                    <div class="col-4 customLabel">Travel Callout Charges:
                      @if (getPermission('Service_otherCCMP')?.required ) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-6">
                      <ejs-numerictextbox
                      [min]="0"
                      [max]="9999999999"
                      [maxlength]="10"
                      [format]="'n'"
                      [showSpinButton]="false"
                      (change)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-travelCalloutCharges change')"
                      [enabled]="getPermission('Service_otherCCMP')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Service_otherCCMP')?.readOnly || !isSectionEnabled"
                      formControlName="travelCalloutCharges"
                      placeholder="Travel Callout Charges"
                      >
                    </ejs-numerictextbox>
                      <div class="field-error"
                        [ngStyle]="{visibility: (isFormSubmitted && getPermission('Service_travelCalloutCharges')?.required && serviceForm.controls.travelCalloutCharges.invalid) ? 'visible' : 'hidden'}">
                        Field is required</div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>

        @if (getPermission('Service_preferencesSection')?.visible) {
        <div class="row">
          <div class="col-12 m-auto">
            <div style="font-weight: bold; font-size: 13px !important; margin: 20px 10px;">Preferences</div>
          </div>
          <div class="col-12 control-section">
            <app-up-preferences
            [userProfile]="$safeNavigationMigration(serviceForm?.value)"
            [isSectionEnabled]="isSectionEnabled"
            [configs]="servicePreferencesConfig"
            [actions]="action"
            [source]="source"
            (onPreferencesModified)="sectionModified({modified: $event, section: UPEnums.ServicePreferencesData}, 'html-preferences change')"
            ></app-up-preferences>
          </div>
        </div>
        }



      </div>

} @else {
    <div class="profile-skeleton">

  <!-- Top Profile Section -->
  <div class="profile-header">
    <!-- <div class="profile-avatar shimmer"></div> -->

    <div class="profile-details">
      <div class="detail-line large shimmer"></div>
      <div class="detail-line shimmer"></div>
      <div class="detail-line shimmer short"></div>

      <div class="detail-grid">
        <div class="detail-item shimmer" *ngFor="let i of [1,2,3,4]"></div>
      </div>
    </div>
  </div>


  <!-- Table Section -->
  <div class="section">
    <div class="section-title shimmer"></div>
    <div class="table-skeleton">
      <div class="table-row shimmer" *ngFor="let i of [1,2]"></div>
    </div>
  </div>

</div>

  
}

    </div>
  </div>
</div>
<!-- Details Section Ends -->
}

@if (showAdvancedEmployeesSearchPopup) {
  <app-advanced-employee-search-popup
  [configs]="advancedSearchEmployeesConfigurations"
  (onClose)="showAdvancedEmployeesSearchPopup = false;"
  (onEmployeeSelected)="sectionModified({modified: $event, section: UPEnums.ServicesFormData}, 'html-advanced-employee-search-popup');onEmployeeIdChange({isInteracted: true}, $event);"
  (assigneISCManagerDetailsToISC)="sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'html-advanced-isc-manager-details');assigneISCManagerDetailsToISC($event);"
  >
</app-advanced-employee-search-popup>
}
@if (showAdvancedISCCodePopup) {
  <app-advanced-isc-codes-popup
  (onClose)="showAdvancedISCCodePopup = false;"
  (onISCCodeSelected)="onISCCodeSelected($event);">
  </app-advanced-isc-codes-popup>
}

